const state = {
    boards: [],
    isedit: false
}

const mutations = {
    MODIFY_BOARDS: (state, boards) => {
        state.boards = boards
    },
    MODIFY_EDIT: (state, isedit) => {
        state.isedit = isedit
    }
}

const actions = {
    modifyBoards({ commit }, boards) {
        commit('MODIFY_BOARDS', boards)
    },
    modifyEdit({ commit }, isedit) {
        commit('MODIFY_EDIT', isedit)
    }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

